import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as appConstants from '../../../overrides/appconstants'
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import * as actions from '../actions/micustomeractions'
import Select from 'react-select';
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';
import * as constant from '../constants'
import { Search } from '@mui/icons-material';
import SearchQuote from './SearchQuote';
import CustomPager from '../../../components/custompager';
import Documents from "./Documents";
export default function MemberFullDetails() {

    const dispatch = useDispatch();
    const state = useSelector(state => state.miCustomerSharedReducer);
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    var masters = state.masters;
    // let newEnq = state.basicInfoNewEnq;
    // let modalState = state.modalState;
    // let memberDetails = state.memberBasicInfo;
    let quoteMembersList = state?.quoteMembers?.quoteMembersList;
    let currentQuoteMember = state?.quoteMembers?.currentQuoteMember;
    let documents = state.quoteDocuments;
    let quoteMembers = state?.quoteMembers;
    let basicInfoNewEnq = state.basicInfoNewEnq;
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const enquiryId = queryParams.get("enquiryId");

    let isCustomerConfirmed = basicInfoNewEnq?.isCustomerConfirmed == true

    useEffect(() => {
        let valuesToMap = [
            { "salutation": currentQuoteMember.salutation },
            { "firstName": currentQuoteMember.firstName },
            { "middleName": currentQuoteMember.middleName },
            { "lastName": currentQuoteMember.lastName },
            { "emiratesId": currentQuoteMember.emiratesId },
            { "memberDateOfBirth": currentQuoteMember.memberDateOfBirth },
            { "nationality": currentQuoteMember.nationality },
            { "memberGender": currentQuoteMember.memberGender },
            { "memberMaritalStatus": currentQuoteMember.memberMaritalStatus },
            { "relation": currentQuoteMember.relation },
            { "passPortNo": currentQuoteMember.passPortNo },
            { "memberVisaType": currentQuoteMember.memberVisaType },
            // { "entityId": currentQuoteMember.entityId },
            { "salaryBand": currentQuoteMember.salaryBand },
            { "address": currentQuoteMember.address },
            { "poBox": currentQuoteMember.poBox },
            { "uIDNumber": currentQuoteMember.uIDNumber },
            { "visaFileNumber": currentQuoteMember.visaFileNumber },
            { "memberType": currentQuoteMember.memberType },
            { "birthCertificateNumber": currentQuoteMember.birthCertificateNumber },
            { "memberEntryDate": currentQuoteMember.memberEntryDate },
            { "previousInsuranceCompany": currentQuoteMember.previousInsuranceCompany },
            { "previousInsuranceNumber": currentQuoteMember.previousInsuranceNumber },
            { "previousInsuranceExpiryDt": currentQuoteMember.previousInsuranceExpiryDt },
            { "isFirstPolicy": currentQuoteMember.isFirstPolicy },
            { "workEmirate": currentQuoteMember.workEmirate },
            { "workLocation": currentQuoteMember.workLocation },
            { "residentEmirate": currentQuoteMember.residentEmirate },
            { "residentLocation": currentQuoteMember.residentLocation },
            { "cocRefNo": currentQuoteMember.cocRefNo },
            { "isSalaryCommissionBased": currentQuoteMember.isSalaryCommissionBased },
            { "visaEmirate": currentQuoteMember.visaEmirate },
            { "profession": currentQuoteMember.profession },
            { "salary": currentQuoteMember.salary },
            { "visaLocation": currentQuoteMember.visaLocation },
            { "idType": currentQuoteMember.idType },
        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setValue(key, i[key])));
    }, [currentQuoteMember]);

    const onFirstPolicy = async (status) => {
        await dispatch(actions.updateCurrentMemberInfoChange({ name: "isFirstPolicy", value: status }));
    }

    const onSalaryCommission = async (status) => {
        await dispatch(actions.updateCurrentMemberInfoChange({ name: "isSalaryCommissionBased", value: status }));
    }

    const onSubmit = async () => {
        console.log('Form Data:', state.basicInfoNewEnq);
        var validated = await dispatch(actions.validateUpdateQuoteMember(state?.quoteMembers?.currentQuoteMember));
        if(!validated){
            return false;
        }
        await dispatch(actions.updateQuoteMember(state?.quoteMembers?.currentQuoteMember));
    };

    const onErrors = (error) => {
        console.log('Form Error:', error);
    };

    // Function to check if the birth year is the same as the current year
    const isSameYearAsCurrent = (memberDateOfBirth) => {
        const currentDate = new Date();
        const birthDate = new Date(memberDateOfBirth);
        return birthDate.getFullYear() == currentDate.getFullYear();
    };
    const compareEmiratesIdYear = (val) => {
        try {
            if (!val) return true;
            var dateofBirth = new Date(currentQuoteMember?.memberDateOfBirth);
            var year = dateofBirth.getFullYear();
            var blankYear = '1111';
            const getYearFromEmiratesID = s => s.includes('-') && s.substr(s.indexOf('-') + 1).split('-')[0];
            if (year == getYearFromEmiratesID(val) || getYearFromEmiratesID(val) == blankYear) {
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    const checkAgeLimit = (val) => {
        // if (insuredInforamtion.memberDateOfBirth == null || insuredInforamtion.memberDateOfBirth == '') {
        //     return false;
        // }
        let today = new Date()
        let date1 = today.getDate() + '-' + parseInt(today.getMonth() + 1) + '-' + today.getFullYear()
        try {
            if (!val) return true;
            const dt_date1 = new Date(val);
            const dt_date2 = new Date(today);
            const date1_time_stamp = dt_date1.getTime();
            const date2_time_stamp = dt_date2.getTime();
            let calc;
            if (date1_time_stamp > date2_time_stamp) {
                calc = new Date(date1_time_stamp - date2_time_stamp);
            } else {
                calc = new Date(date2_time_stamp - date1_time_stamp);
            }
            const calcFormatTmp = calc.getDate() + '-' + (calc.getMonth() + 1) + '-' + calc.getFullYear();
            const calcFormat = calcFormatTmp.split("-");
            const years_passed = Number(Math.abs(calcFormat[2]) - 1970);
            let result = false;
            if (years_passed >= 18) {
                result = true;
            }
            return result;
        }
        catch (error) {
            return false;
        }
    }

    useEffect(() => {
        try {
            if ((currentQuoteMember.workEmirate != null) && (currentQuoteMember.workEmirate != "")) {
                dispatch(actions.getLocationMaster("workEmirate", currentQuoteMember.workEmirate));
            }
        } catch (error) {
            console.error('Error in useEffect:', error);
        }
    }, [currentQuoteMember.workEmirate]);

    useEffect(() => {
        try {
            if ((currentQuoteMember.residentEmirate != null) && (currentQuoteMember.residentEmirate != "")) {
                dispatch(actions.getLocationMaster("residentEmirate", currentQuoteMember.residentEmirate));
            }
        } catch (error) {
            console.error('Error in useEffect:', error);
        }
    }, [currentQuoteMember.residentEmirate]);

    useEffect(() => {
        try {
            if ((currentQuoteMember.visaEmirate != null) && (currentQuoteMember.visaEmirate != "")) {
                dispatch(actions.getLocationMaster("visaEmirate", currentQuoteMember.visaEmirate));
            }
        } catch (error) {
            console.error('Error in useEffect:', error);
        }
    }, [currentQuoteMember.visaEmirate]);

    const handleCurrentMemberInfoChange = async (e) => {
        var { name, value } = e.target;
        if (name == "emiratesId") {
            if (e.target.value.length === 3 && !currentQuoteMember.emiratesId.match(/.*-$/)) {
                value = value += "-"
            }
            if (e.target.value.length === 8 && !currentQuoteMember.emiratesId.match(/.*-$/)) {
                value = value += "-"
            }
            if (e.target.value.length === 16 && !currentQuoteMember.emiratesId.match(/.*-$/)) {
                value = value += "-"
            }
            value = value.substr(0, 18);
        }
        if (name == "salutation" || name == "nationality" || name == "memberGender" || name == "memberMaritalStatus" || name == "relation"
            || name == "memberVisaType" /* || name == "entityId" */ || name == "salaryBand") {
            value = value === "" ? null : Number(value);
        }
        if (name === "workEmirate" || name === "residentEmirate" || name === "visaEmirate") {
            if ((name === "workEmirate") && (value === "" || value === null)) {
                dispatch(actions.getWorkLocationMasterEnd([{ cityId: 0, cityName: null }]));
                await dispatch(actions.updateCurrentMemberInfoChange({ name, value }));
                return;
            }
            if ((name === "residentEmirate") && (value === "" || value === null)) {
                dispatch(actions.getResidentLocationMasterEnd([{ cityId: 0, cityName: null }]));
                await dispatch(actions.updateCurrentMemberInfoChange({ name, value }));
                return;
            }
            if ((name === "visaEmirate") && (value === "" || value === null)) {
                dispatch(actions.getVisaLocationMasterEnd([{ cityId: 0, cityName: null }]));
                await dispatch(actions.updateCurrentMemberInfoChange({ name, value }));
                return;
            }
            await dispatch(actions.getLocationMaster(name, value));
        }
        await dispatch(actions.updateCurrentMemberInfoChange({ name, value }));
    }

    let Salutation =
        <select className={errors.salutation ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="salutation"
            name="salutation"
            value={currentQuoteMember.salutation}
            disabled={isCustomerConfirmed}
            {...register("salutation", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })} >
            <option value=''>Select</option>
            {masters?.salutationMasters?.map((SalutationMasters, index) => (

                <option value={SalutationMasters.domainValue} key={index}>
                    {SalutationMasters.domainValueName}
                </option>
            ))}
        </select>

    let FirstName =
        <input className={errors.firstName ? 'form-control is-invalid' : 'form-control'}
            id="firstname"
            required=""
            placeholder="Enter First name"
            name='firstName'
            value={currentQuoteMember.firstName}
            disabled={isCustomerConfirmed}
            {...register("firstName", {
                required: true,
                validate: {
                    specialCharCheck: (v) => !appUtility.CheckSpecialCharASCII(v) || "Special characters are not allowed",
                },
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let MiddleName =
        <input className={errors.middleName ? 'form-control is-invalid' : 'form-control'}
            type="text"
            id="middleName"
            required=""
            placeholder="Enter Middle name"
            name='middleName'
            value={currentQuoteMember.middleName}
            disabled={isCustomerConfirmed}
            {...register("middleName", {
                // required: true,
                validate: {
                    specialCharCheck: (v) => !appUtility.CheckSpecialCharASCII(v) || "Special characters are not allowed",
                },
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let LastName =
        <input className={errors.lastName ? 'form-control is-invalid' : 'form-control'}
            type="text"
            id="lastName"
            required=""
            placeholder="Enter Last Name"
            name='lastName'
            value={currentQuoteMember.lastName}
            disabled={isCustomerConfirmed}
            {...register("lastName", {
                required: true,
                validate: {
                    specialCharCheck: (v) => !appUtility.CheckSpecialCharASCII(v) || "Special characters are not allowed",
                },
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let EmiratesID =
        <input className={errors.emiratesId ? 'form-control is-invalid' : 'form-control'}
            placeholder="Enter Emirates ID"
            id="emiratesId"
            name="emiratesId"
            value={currentQuoteMember.emiratesId}
            disabled={isCustomerConfirmed}
            {...register("emiratesId", {
                required: true,
                validate: {
                    yearscheck: (v) => compareEmiratesIdYear(v)
                },
                pattern: { value: /(^[7][8][4][-][0-9]{4}[-][0-9]{7}[-][0-9]{1}$)|(^[1][1][1][-][1]{4}[-][1]{7}[-][1]{1}$)/, message: "Format: XXX-XXXX-XXXXXXX-X" },
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let DateofBirth =
        <input className={errors.memberDateOfBirth ? 'form-control is-invalid' : 'form-control'}
            type="date"
            id="memberDateOfBirth"
            required=""
            placeholder="Enter Date of Birth"
            name='memberDateOfBirth'
            disabled={true}
            value={currentQuoteMember.memberDateOfBirth}
            {...register("memberDateOfBirth", {
                required: true,
                // validate: {
                //     agecheck: (value) => checkAgeLimit(value)
                // },
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let Nationality =
        <select className={errors.nationality ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="nationality"
            name="nationality"
            value={currentQuoteMember.nationality}
            disabled={isCustomerConfirmed}
            {...register("nationality", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })} >
            <option value=''>Select </option>
            {masters?.nationalityMaster?.map((NationalityMasters, index) => (
                <option value={NationalityMasters.domainValue} key={index}>
                    {NationalityMasters.domainValueName}
                </option>
            ))
            }
        </select>    
        let IdType =
        <select className={errors.idType ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="idType"
            name="idType"
            value={currentQuoteMember.idType}
            disabled={isCustomerConfirmed}
            {...register("idType", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })} >
            <option value=''>Select </option>
            {masters?.idTypeMasters?.map((NationalityMasters, index) => (
                <option value={NationalityMasters.domainValue} key={index}>
                    {NationalityMasters.domainValueName}
                </option>
            ))
            }
        </select>

    let Gender =
        <select className={errors.memberGender ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="memberGender"
            name="memberGender"
            {...register("memberGender", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
            disabled={true}
            value={currentQuoteMember.memberGender}
        >
            <option value=''>Select </option>
            {
                masters?.genderMasters?.map((memberGender, index) => (

                    <option value={memberGender.id} key={index}>
                        {memberGender.name}
                    </option>
                ))
            }
        </select>

    let memberMaritalStatus =
        <select className={errors.memberMaritalStatus ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="memberMaritalStatus"
            name="memberMaritalStatus"
            disabled={true}
            {...register("memberMaritalStatus", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
            value={currentQuoteMember.memberMaritalStatus}
        >
            <option value=''>Select </option>
            {
                masters?.maritalStatusMasters?.map((maritalSatusMasters, index) => (

                    <option value={maritalSatusMasters.id} key={index}>
                        {maritalSatusMasters.name}
                    </option>
                ))
            }
        </select>

    let Relation =
        <select className={`form-select ${errors.relation ? "is-invalid" : ""}`}
            value={currentQuoteMember.relation}
            disabled={true}
            {...register(`relation`, {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
            id={"relation"}
        >
            <option value="">--Relation--</option>
            {masters?.relationMasters?.map(relation => (
                <option key={relation.id} value={relation.id}>
                    {relation.name}
                </option>
            ))}
        </select>

    let PassportNo =
        <input
            className={errors.passPortNo ? 'form-control is-invalid' : 'form-control'}
            type="text"
            id="passPortNo"
            required=""
            placeholder="Enter Passport"
            name="passPortNo"
            value={currentQuoteMember.passPortNo}
            disabled={isCustomerConfirmed}
            {...register("passPortNo", {
                required: "Passport number is required",
                pattern: {
                    value: /^[a-zA-Z0-9]+$/,
                    message: "Only letters, numbers"
                },
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let VisaType =
        <select className={errors.memberVisaType ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="memberVisaType"
            name="memberVisaType"
            tabIndex={14}
            disabled={isCustomerConfirmed}
            {...register("memberVisaType", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })} >
            <option value=''>--Visa Type-- </option>
            {masters?.memberVisaType?.map((memberVisaType) => (
                <option value={memberVisaType.domainValue} key={memberVisaType.domainValue}>
                    {memberVisaType.domainValueName}
                </option>
            ))}
        </select>

    // let EntityType =
    //     <select className={errors.entityId ? 'form-control is-invalid' : 'form-control'}
    //         data-toggle="entityId"
    //         id="entityId"
    //         name="entityId"
    //         tabIndex={15}
    //         value={currentQuoteMember.entityId}
    //         {...register("entityId", {
    //             required: true,
    //             onChange: (e) => handleCurrentMemberInfoChange(e)
    //         })}>
    //         <option value=''>--Entity--</option>
    //         {masters?.entityTypeMasters?.map((policyMasters) => (
    //             <option value={policyMasters.domainValue} key={policyMasters.domainValue}>
    //                 {policyMasters.domainValueName}

    //             </option>
    //         ))}
    //     </select>

    let salaryBand =
        <select className={errors.salaryBand ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="salaryBand"
            name="salaryBand"
            {...register("salaryBand", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
            value={currentQuoteMember.salaryBand}
            disabled={isCustomerConfirmed}
        >
            <option value=''>--Salary Band-- </option>
            {
                masters?.salaryBandMasters?.map((salary, index) => (

                    <option value={salary.domainValue} key={index}>
                        {salary.domainValueName}
                    </option>
                ))
            }
        </select>

    let Address =
        <input className={errors.address ? 'form-control is-invalid' : 'form-control'}
            type="text"
            id="address"
            required=""
            placeholder="Enter Address"
            name='address'
            value={currentQuoteMember.address}
            disabled={isCustomerConfirmed}
            {...register("address", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let poBox =
        <input className={errors.poBox ? 'form-control is-invalid' : 'form-control'}
            type="text"
            id="poBox"
            required=""
            placeholder="Enter P.O. Box"
            name='poBox'
            value={currentQuoteMember.poBox}
            disabled={isCustomerConfirmed}
            {...register("poBox", {
                required: false,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let uIDNumber =
        <input className={errors.uIDNumber ? 'form-control is-invalid' : 'form-control'}
            type="number"
            id="uIDNumber"
            required=""
            placeholder="Enter UID Number"
            name='uIDNumber'
            value={currentQuoteMember.uIDNumber}
            disabled={isCustomerConfirmed}
            {...register("uIDNumber", {
                required: true,
                pattern: {
                    value: /^[0-9]+$/,
                    message: "Only letters, numbers"
                },
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let visaFileNumber =
        <input className={errors.visaFileNumber ? 'form-control is-invalid' : 'form-control'}
            type="text"
            id="visaFileNumber"
            required=""
            placeholder="Enter Visa File Number"
            name='visaFileNumber'
            value={currentQuoteMember.visaFileNumber}
            disabled={isCustomerConfirmed}
            {...register("visaFileNumber", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let MemberType =
        <select className={errors.memberType ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="memberType"
            name="memberType"
            value={currentQuoteMember.memberType}
            disabled={isCustomerConfirmed}
            {...register("memberType", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })} >
            <option value=''>--Member Type-- </option>
            {masters?.memberTypeMaster?.map((memberType) => (
                <option value={memberType.domainValue} key={memberType.domainValue}>
                    {memberType.domainValueName}

                </option>
            ))}
        </select>

    let birthCertificateNumber =
        <input className={errors.birthCertificateNumber ? 'form-control is-invalid' : 'form-control'}
            type="text"
            id="birthCertificateNumber"
            required=""
            placeholder="Enter Birth Certificate"
            name='birthCertificateNumber'
            value={currentQuoteMember.birthCertificateNumber}
            disabled={isCustomerConfirmed}
            {...register("birthCertificateNumber", {
                required: currentQuoteMember.memberType == appConstants.DHA_MEMBER_TYPE_NEW_BORN,
                // required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let memberEntryDate =
        <input className={errors.memberEntryDate ? 'form-control is-invalid' : 'form-control'}
            type="date"
            id="memberEntryDate"
            required=""
            placeholder="Enter Date"
            name='memberEntryDate'
            value={currentQuoteMember.memberEntryDate}
            disabled={isCustomerConfirmed}
            {...register("memberEntryDate", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let firstPolicy = (
        <div className='btn-group'>
            <button className={currentQuoteMember.isFirstPolicy ? "btn btn-primary" : "btn btn-outline-primary"}
                data-bs-container="#tooltip-container2"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                title="Yes"
                type="button"
                // value={currentQuoteMember.isFirstPolicy}
                disabled={isCustomerConfirmed}
                onClick={() => onFirstPolicy(true)}> Yes</button>

            <button className={!currentQuoteMember.isFirstPolicy ? "btn btn-info" : "btn btn-outline-info"}
                data-bs-container="#tooltip-container2"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                title="No"
                type="button"
                // value={currentQuoteMember.isFirstPolicy}
                disabled={isCustomerConfirmed}
                onClick={() => onFirstPolicy(false)}> No</button>
        </div>);

    let previousInsuranceCompany =
        <input className={errors.previousInsuranceCompany ? 'form-control is-invalid' : 'form-control'}
            type="text"
            id="previousInsuranceCompany"
            required=""
            placeholder="Enter Company"
            name='previousInsuranceCompany'
            value={currentQuoteMember.previousInsuranceCompany}
            disabled={isCustomerConfirmed}
            {...register("previousInsuranceCompany", {
                required: currentQuoteMember.isFirstPolicy || (currentQuoteMember?.visaEmirate != appConstants.VISA_EMIRATE_ABU_DHABI && currentQuoteMember?.visaEmirate != appConstants.VISA_EMIRATE_AL_AIN) ? false : "This field is required.",
                validate: value => currentQuoteMember.isFirstPolicy || value !== "" || "This field is required.",
                // required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let previousInsuranceNumber =
        <input className={errors.previousInsuranceNumber ? 'form-control is-invalid' : 'form-control'}
            type="text"
            id="previousInsuranceNumber"
            required=""
            placeholder="Enter Birth Certificate"
            name='previousInsuranceNumber'
            value={currentQuoteMember.previousInsuranceNumber}
            disabled={isCustomerConfirmed}
            {...register("previousInsuranceNumber", {
                required: currentQuoteMember.isFirstPolicy || (currentQuoteMember?.visaEmirate != appConstants.VISA_EMIRATE_ABU_DHABI && currentQuoteMember?.visaEmirate != appConstants.VISA_EMIRATE_AL_AIN) ? false : "This field is required.",
                validate: value => currentQuoteMember.isFirstPolicy || value !== "" || "This field is required.",
                // required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let previousInsuranceExpiryDt =
        <input className={errors.previousInsuranceExpiryDt ? 'form-control is-invalid' : 'form-control'}
            type="date"
            id="previousInsuranceExpiryDt"
            required=""
            placeholder="Enter Birth Certificate"
            name='previousInsuranceExpiryDt'
            value={currentQuoteMember.previousInsuranceExpiryDt}
            disabled={isCustomerConfirmed}
            {...register("previousInsuranceExpiryDt", {
                required: currentQuoteMember.isFirstPolicy ? false : "This field is required.",
                validate: value => currentQuoteMember.isFirstPolicy || value !== "" || "This field is required.",
                // required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let WorkEmirate =
        <select className={errors.workEmirate ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="workEmirate"
            name='workEmirate'
            disabled={isCustomerConfirmed}
            {...register("workEmirate", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
            value={currentQuoteMember.workEmirate}
        >
            <option value=''>--Work Emirate--</option>
            {masters?.visaEmirateMasters?.filter(emirate => !appConstants.VISA_EMIRATE_COUNTRY.includes(emirate.id))?.map((workEmirate) => (

                <option value={workEmirate.id} key={workEmirate.id}>
                    {workEmirate.name}
                </option>
            ))}
        </select>

    let WorkLocation =
        <select className={errors.workLocation ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="workLocation"
            name='workLocation'
            disabled={isCustomerConfirmed}
            {...register("workLocation", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
            value={currentQuoteMember.workLocation}
        >
            <option value=''>--Work Location--</option>
            {masters?.workLocationMasters?.map((workLocation) => (
                <option value={workLocation.cityId} key={workLocation.cityId}>
                    {workLocation.cityName}
                </option>
            ))}
        </select>

    let COCRefNumber =
        <input className={errors.cocRefNo ? 'form-control is-invalid' : 'form-control'}
            type="text"
            id="cocRefNo"
            required=""
            placeholder="COC Reference Number"
            name='cocRefNo'
            value={currentQuoteMember.cocRefNo}
            disabled={isCustomerConfirmed}
            {...register("cocRefNo", {
                // required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
        />

    let ResidentEmirate =
        <select className={errors.residentEmirate ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="residentEmirate"
            name='residentEmirate'
            disabled={isCustomerConfirmed}
            {...register("residentEmirate", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
            value={currentQuoteMember.residentEmirate}
        >
            <option value=''>--Resident Emirate--</option>
            {masters?.visaEmirateMasters?.filter(emirate => !appConstants.VISA_EMIRATE_COUNTRY.includes(emirate.id))?.map((residentEmirate) => (

                <option value={residentEmirate.id} key={residentEmirate.id}>
                    {residentEmirate.name}
                </option>
            ))}
        </select>

    let ResidentLocation =
        <select className={errors.residentLocation ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="residentLocation"
            name='residentLocation'
            disabled={isCustomerConfirmed}
            {...register("residentLocation", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
            value={currentQuoteMember.residentLocation}
        >
            <option value=''>--Resident Location--</option>
            {masters?.residentLocationMasters?.map((residentLocation) => (
                <option value={residentLocation.cityId} key={residentLocation.cityId}>
                    {residentLocation.cityName}
                </option>
            ))}
        </select>

    let visaEmirate =
        <select className={errors.visaEmirate ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="visaEmirate"
            name='visaEmirate'
            disabled={true}
            {...register("visaEmirate", {
                // required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
            value={currentQuoteMember.visaEmirate}
        >
            <option value=''>--Visa Emirate--</option>
            {masters?.visaEmirateMasters?.map((workEmirate) => (
                <option value={workEmirate.id} key={workEmirate.id}>
                    {workEmirate.name}
                </option>
            ))}
        </select>

    let visaLocation =
        <select className={errors.visaLocation ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="visaLocation"
            name='visaLocation'
            disabled={isCustomerConfirmed}
            {...register("visaLocation", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
            value={currentQuoteMember.visaLocation}
        >
            <option value=''>--Visa Location--</option>
            {masters?.visaLocationMasters?.map((residentLocation) => (
                <option value={residentLocation.cityId} key={residentLocation.cityId}>
                    {residentLocation.cityName}
                </option>
            ))}
        </select>

    let Profession =
        <select className={errors.profession ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2"
            id="profession"
            disabled={isCustomerConfirmed}
            {...register("profession", {
                required: true,
                onChange: (e) => handleCurrentMemberInfoChange(e)
            })}
            value={currentQuoteMember.profession}
        >
            <option value=''>--Profession--</option>
            {masters?.professionMasters?.map((profession) => (
                <option value={profession.domainValue} key={profession.domainValue}>
                    {profession.domainValueName}
                </option>
            ))}
        </select>

    let Salary = <input className={errors.salary ? 'form-control is-invalid' : 'form-control'}
        type="number"
        id="salary" required=""
        placeholder="Enter Salary"
        name='salary'
        disabled={isCustomerConfirmed}
        // readOnly={memberInformation.isSalaryZero}
        {...register("salary", {
            required: false,
            // validate: !memberInformation.isPrincipal || {
            //     greaterthan: (v) => parseInt(v) >= memberInformation.minSalary,
            //     lessthan: (v) => parseInt(v) <= memberInformation.maxSalary
            // },
            onChange: (e) => handleCurrentMemberInfoChange(e)
        })}
        value={currentQuoteMember.salary}
    />

    let salaryCommission =
        <div className='btn-group'>
            <button className={currentQuoteMember.isSalaryCommissionBased ? "btn btn-primary" : "btn btn-outline-primary"}
                data-bs-container="#tooltip-container2"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                title="Yes"
                type="button"
                disabled={isCustomerConfirmed}
                // value={currentQuoteMember.isSalaryCommissionBased}
                onClick={() => onSalaryCommission(true)}> Yes</button>

            <button className={!currentQuoteMember.isSalaryCommissionBased ? "btn btn-info" : "btn btn-outline-info"}
                data-bs-container="#tooltip-container2"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                title="No"
                type="button"
                disabled={isCustomerConfirmed}
                // value={currentQuoteMember.isSalaryCommissionBased}
                onClick={() => onSalaryCommission(false)}> No</button>
        </div>


    const setSelectedMember = async (memberId) => {

        if (memberId !== null && memberId !== "") {
            dispatch(actions.setCurrentQuoteMember(memberId));
            // if (documents.documentList.length === 0) {
            await dispatch(actions.getQuoteDocumentMasters(Number(memberId), enquiryId));
            // }
            await dispatch(actions.showQuoteDocumentTab());
            await dispatch(actions.getQuoteDocuments(Number(memberId)), enquiryId);
        }
        else {
            dispatch(actions.setCurrentQuoteMembertoNull());
        }
    }

    function renderMemberDetails() {
        console.log('currentQuoteMember', currentQuoteMember);

        return (
            <>
                <div className="collapse show" id="CollapseMemberDetails">
                    <div className="row g-2">
                        <div className="mb-3 col-md-6">
                            <label for="members" className="form-label"> Select a Member</label>
                            <span className='text-danger fst-italic'> ** Please choose a member to view</span>
                            <select
                                className={`form-control ${errors[`members`] ? "is-invalid" : ""}`}
                                data-toggle="select2"
                                name="members"
                                id="members"
                                {...register(`members`, {
                                    onChange: (e) => {
                                        setSelectedMember(e.target.value);
                                    }
                                })}
                            >
                                {/* filter(member => (member?.notMember == false) && (member?.relation !== appConstants.RELATION_PRINCIPAL_ID) && (member?.memberId != null))?. */}
                                <option value="">-- Select Member --</option>
                                {quoteMembersList?.filter(member => (member?.memberId != null))?.map((member, index) => (
                                    <option key={index} value={member.memberId}>
                                        {member.memberFullName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <ul className="nav nav-tabs nav-bordered mb-1">
                    <li className="nav-item">
                        <span >
                            Member Details
                        </span>
                    </li>
                </ul>

                <div className="collapse show" id="CollapseMemberDetails">
                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <div className="input-group">
                                <div className="col-md-4">
                                    <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span> Salutation</label>
                                    {Salutation}
                                </div> <div className="col-md-8">
                                    <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span> First Name</label>
                                    {FirstName}
                                    {errors.firstName && (<div className="invalid-feedback">{errors.firstName.message}</div>)}
                                </div></div></div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"> Middle Name</label>
                            {MiddleName}
                            {errors.middleName && (<div className="invalid-feedback">{errors.middleName.message}</div>)}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Last Name</label>
                            {LastName}
                            {errors.lastName && (<div className="invalid-feedback">{errors.lastName.message}</div>)}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Date Of Birth</label>
                            {DateofBirth}
                            {errors.memberDateOfBirth && (<div className="invalid-feedback">{errors.memberDateOfBirth.message}</div>)}
                        </div>
                    </div>
                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Emirates ID</label>
                            {EmiratesID}
                            {errors.emiratesId && <p className="text-danger fst-italic fs-6">{errors.emiratesId.message}</p>}
                            {errors.emiratesId?.type === "yearscheck" && <span className='text-danger'>Date of Birth Year and Emirates Id Year not Valid</span>}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Nationality</label>
                            {Nationality}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Gender</label>
                            {Gender}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Marital Status</label>
                            {memberMaritalStatus}
                        </div>
                    </div>
                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Relation</label>
                            {Relation}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Passport Number</label>
                            {PassportNo}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Visa Type</label>
                            {VisaType}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Salary Band</label>
                            {salaryBand}
                        </div>
                        {/* <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Entity</label>
                            {EntityType}
                        </div> */}
                    </div>
                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Work Emirate</label>
                            {WorkEmirate}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Work Location</label>
                            {WorkLocation}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Resident Emirate</label>
                            {ResidentEmirate}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Resident Location</label>
                            {ResidentLocation}
                        </div>
                    </div>
                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label">{/* <span style={{ color: 'red' }}>*</span>  */} Visa Emirate</label>
                            {visaEmirate}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Visa Location</label>
                            {visaLocation}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Profession</label>
                            {Profession}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label">   Salary</label>
                            {Salary}
                        </div>
                    </div>
                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Address</label>
                            {Address}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label">  P.O. Box</label>
                            {poBox}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  UID Number</label>
                            {uIDNumber}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Visa File Number</label>
                            {visaFileNumber}
                        </div>
                    </div>
                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Member Type</label>
                            {MemberType}
                        </div>
                        {
                            isSameYearAsCurrent(currentQuoteMember?.memberDateOfBirth) &&

                            <div className="mb-3 col-md-3">
                                <label for="inputPassword4" className="form-label">{currentQuoteMember.memberType == appConstants.DHA_MEMBER_TYPE_NEW_BORN &&
                                    <span style={{ color: 'red' }}>*</span>} Birth Certificate Number</label>
                                {birthCertificateNumber}
                            </div>
                        }
                        {(currentQuoteMember.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || currentQuoteMember.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span> Entry/Last Coverage Date</label>
                            {memberEntryDate}
                        </div>}
                        <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Salary Commission Based? &nbsp; </label>
                            {salaryCommission}
                        </div>
                    </div >
                    <div className="row g-2">
                        {(currentQuoteMember.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || currentQuoteMember.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && <div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  COC Reference Number</label>
                            {COCRefNumber}
                        </div>}
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  First Policy? &nbsp; </label>
                            {firstPolicy}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Member ID Type &nbsp; </label>
                            {IdType}
                        </div>
                        {!currentQuoteMember.isFirstPolicy && (currentQuoteMember?.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || currentQuoteMember?.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && <><div className="mb-3 col-md-3">
                            <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span> Previous Insurance Company</label>
                            {previousInsuranceCompany}
                        </div>
                            <div className="mb-3 col-md-3">
                                <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span> Previous Insurance Number</label>
                                {previousInsuranceNumber}
                            </div>
                            <div className="mb-3 col-md-3">
                                <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span>  Previous Insurance Expiry Date</label>
                                {previousInsuranceExpiryDt}
                            </div></>}
                    </div>
                    <div className="row g-2">
                        <div className="mb-3 col-md-12 d-flex justify-content-end">
                            <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-end' }}>

                                {/* <Button
                                    className='mx-2'
                                    variant="outlined"
                                    type='button'
                                    color="secondary"
                                    onClick={() => onBackPressed()}
                                    startIcon={<ArrowBackIcon />}

                                >
                                    Back
                                </Button> */}

                                {!isCustomerConfirmed && quoteMembers?.currentQuoteMember?.memberId && <Button
                                    variant="contained"
                                    color="success"
                                    type="submit"
                                    disabled={isCustomerConfirmed}
                                >
                                    Save
                                </Button>}

                            </Box>

                            {/* <button type="button" className="btn btn-success">Button</button> */}
                        </div>
                    </div>
                </div>


            </>
        )
    }

    return (
        <>
            <div className="row g-2">
                <div className="mb-1 col-md-12">
                </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit, onErrors)}>
                <div className="mt-2" >
                    <div className="container">
                        {renderMemberDetails()}

                    </div>
                </div>
            </form>
            {documents?.showDocumentsTab && <Documents />}
        </>
    )
}